module.exports = __webpack_public_path__ + "assets/28b70a51795b8c8df9bc6019c6ce7ed8.png";